import { AlbumSlider } from './AlbumSlider';
export default AlbumSlider;
